export const IsolationMain = () => {

    return (
        <div className='isolation-bg'>
            <div className='bg-black bg-opacity-70 h-full'>
                <div className='flex flex-col items-center justify-center h-full text-white'>
                    <h1 className='text-6xl lg:text-7xl text-center'>ISOLATION</h1>
                    <h3 className='text-xl'>À l'intérieur et à l'extérieur</h3>
                </div>
            </div>
        </div>
    )
}